//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';
import { FeatureNames } from '@bvengineering/curalate-features';
import { getAreNoCheckboxesSelectedImpl } from '@galleries/selectors/bulk-rights-selectors/getAreNoCheckboxesSelected';

export const getAreNoCheckboxesSelected = createSelector(
  (state: ICuralateStore) =>
    state.uiaModal.approveForGalleries.gallerySelection,
  (state: ICuralateStore) =>
    state.uiaModal.approveForGalleries.isBazaarvoiceSyndicationSelected,
  createHasFeatureSelector(FeatureNames.BazaarvoiceNetworkSyndicationFrontend),
  getAreNoCheckboxesSelectedImpl,
);

export default getAreNoCheckboxesSelected;
